import React, { useEffect } from "react";
import "./App.css";
import { useRequest } from "@umijs/hooks";
import { useHistory } from "react-router-dom";

import { useQuery } from "utils/hook";
import { defaultData, getAll } from "api/index";
import Adcodes from "assets/json/adcode.json";

import AppHeader from "layouts/AppHeader";
import AppMain from "layouts/AppMain";
import AppBox from "layouts/AppBox";
import AppCard from "layouts/AppCard";
import AppSpin from "layouts/AppSpin";

import CityMap from "view/CityMap";
import NumberFlip from "view/NumberFlip";
import Platform from "view/Platform";
import City from "view/City";
import HourTrend from "view/HourTrend";
import AdSpace from "view/AdSpace";
import AdMaterial from "view/AdMaterial";
import ShowType from "view/ShowType";
import AdVideo from "view/AdVideo";
import Age from "view/Age";
import Sexy from "view/Sexy";
import ShowAttention from "view/ShowAttention";
import MediaAttention from "view/MediaAttention";
import Browser from "view/Browser";
import MobBrand from "view/MobBrand";
import BrandAttention from "view/BrandAttention";
import AgencyAd from "view/AgencyAd";

import bg from "assets/images/bg-app-1.jpg";
import bg2 from "assets/images/bg-app-2.jpg";

export const DataContext = React.createContext<AsyncReturnType<typeof getAll>>(
  defaultData
);

function getNextDay() {
  const d = new Date();
  const next =
    new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 1).getTime() +
    24 * 3600000;

  return next - d.getTime();
}

function App() {
  const history = useHistory();
  const query = useQuery();
  const { data = defaultData, loading, run } = useRequest(getAll, {
    manual: true,
    throttleInterval: 600,
  });
  const mapName = (query.get("mapName") as keyof typeof Adcodes) || "全国";

  useEffect(() => {
    if (!Adcodes[mapName]) {
      history.replace("/");
      return;
    }
    let Timer: NodeJS.Timeout;

    function getData() {
      clearTimeout(Timer);
      run(mapName);
      Timer = setTimeout(() => {
        getData();
      }, Math.max(10000, getNextDay() || 10000));
    }

    getData();

    return () => clearTimeout(Timer);
  }, [run, mapName, history]);

  return (
    <DataContext.Provider value={data}>
      <div
        className={`App App-ignore2viewport App-bg ${
          loading ? "App-loading" : ""
        }`}
        style={{
          backgroundImage: `url(${bg})`,
        }}
      >
        <div
          className={`absolute top-0 left-0 w-full h-full App-bg`}
          style={{
            backgroundImage: `url(${bg2})`,
            display: mapName === "全国" ? "none" : "block",
          }}
        ></div>
        <div
          className={`App-bg`}
          style={{
            backgroundImage: `url(${mapName === "全国" ? bg : bg2})`,
          }}
        ></div>
        <AppHeader />
        <AppMain aspectRatio={2560 / (1440 - 116)}>
          {/* <AppMain aspectRatio={2560 / (1440 - 264)}> */}
          <AppBox x="12%" y="6%" w="43%" h="70%">
            <CityMap mapName={mapName} />
          </AppBox>
          <AppBox x="2.5%" y="5%">
            <NumberFlip />
          </AppBox>
          <AppBox x="2%" y="41.5%" w="13%" h="11%">
            <AppCard title="平台曝光" isShort>
              <Platform />
            </AppCard>
          </AppBox>
          <AppBox x="2%" y="54%" w="13%" h="18%">
            <AppCard title="城市等级曝光" isShort>
              <City />
            </AppCard>
          </AppBox>
          <AppBox x="2%" y="72%" w="54%" h="25%">
            <AppCard title="24小时趋势">
              <HourTrend />
            </AppCard>
          </AppBox>
          <AppBox x="58%" y="0%" w="19%" h="22%">
            <AppCard title="广告位类型曝光">
              <AdSpace />
            </AppCard>
          </AppBox>
          <AppBox x="79%" y="0%" w="19%" h="22%">
            <AppCard title="广告素材曝光">
              <AdMaterial />
            </AppCard>
          </AppBox>
          <AppBox x="58%" y="25%" w="19%" h="22%">
            <AppCard title="剧目类型">
              <ShowType />
            </AppCard>
          </AppBox>
          <AppBox x="79%" y="25%" w="19%" h="22%">
            <AppCard title="广告素材欣赏">
              <AdVideo />
            </AppCard>
          </AppBox>
          <div
            className={`absolute ${
              mapName === "全国" ? "toggle-box" : "hidden"
            }`}
            style={{
              top: "0%",
              left: "0%",
              width: "100%",
              height: "100%",
            }}
          >
            <AppBox x="58%" y="50%" w="19%" h="22%">
              <AppCard title="年龄分布">
                <Age />
              </AppCard>
            </AppBox>
            <AppBox x="79%" y="50%" w="19%" h="22%">
              <AppCard title="性别分布">
                <Sexy />
              </AppCard>
            </AppBox>
            <AppBox x="58%" y="75%" w="19%" h="22%">
              <AppCard title="浏览器分布">
                <Browser />
              </AppCard>
            </AppBox>
            <AppBox x="79%" y="75%" w="19%" h="22%">
              <AppCard title="手机品牌分布">
                <MobBrand />
              </AppCard>
            </AppBox>
          </div>
          <div
            className={`absolute ${
              mapName === "全国" ? "toggle-box toggle-box-hidden" : ""
            }`}
            style={{
              top: "0%",
              left: "0%",
              width: "100%",
              height: "100%",
            }}
          >
            <AppBox x="58%" y="50%" w="19%" h="22%">
              <AppCard title="剧目关注度">
                <ShowAttention />
              </AppCard>
            </AppBox>
            <AppBox x="79%" y="50%" w="19%" h="22%">
              <AppCard title="媒体关注度">
                <MediaAttention />
              </AppCard>
            </AppBox>
            <AppBox x="58%" y="75%" w="19%" h="22%">
              <AppCard title="品牌投放指数">
                <BrandAttention />
              </AppCard>
            </AppBox>
            <AppBox x="79%" y="75%" w="19%" h="22%">
              <AppCard title="代理投放指数">
                <AgencyAd />
              </AppCard>
            </AppBox>
          </div>
        </AppMain>
      </div>
      {loading && (
        <div className="loading">
          <AppSpin />
        </div>
      )}
    </DataContext.Provider>
  );
}

export default App;
